import { useState, useEffect } from "react";
import { Box, Container, Text, Image, Select, Spinner, Center } from "@chakra-ui/react";
import axios from "axios";

const Players = () => {

    const [league, setLeague] = useState("2");
    const [playerData, setPlayerData] = useState<any>();
    const [loading, setLoading] = useState(false);
    // const [exhausted, setExhausted] = useState(false);

    const currentYear = new Date().getFullYear() - 1;
    const FOOTBALL_KEY = process.env.REACT_APP_FOOTBALL_API_KEY;

    useEffect(() => {
        setLoading(true);
        let URL = `https://v3.football.api-sports.io/players/topscorers?season=${currentYear}&league=${league}`;
        // ! axios config
        let config: any = {
            method: 'get',
            url: URL,
            headers: { 
            'x-rapidapi-host': 'v3.football.api-sports.io', 
            'x-rapidapi-key': `${FOOTBALL_KEY}`
            }
        };

        axios(config)
        .then((result) => {
            console.log(result);
            setPlayerData(result);
            setLoading(false);
        })
        .catch((error)=> {
            console.log(error);
        setLoading(false);
        })
    },[league])

    return(
        <Container maxW={["container.xl","container.sm"]} mb="20">
            <Text mt="4" fontSize="2xl" color="#ffffff" fontWeight="bold">
                TOP PLAYERS
            </Text>

            <Box mt="3">
            <Select variant='outline' 
            color="#ffffff" onChange={(e) => setLeague(e.target.value)}>
              <option className="select-options" value="2">UEFA Champions League</option>
              <option className="select-options" value="3">UEFA Europa League</option>
              <option className="select-options" value="39">Premier League</option>
              <option className="select-options" value="78">Bundesliga</option>
              <option className="select-options" value="61">League 1</option>
              <option className="select-options" value="135">Seria A</option>
              <option className="select-options" value="140">LaLiga Santander</option>
              <option className="select-options" value="324">I-League</option>
              <option className="select-options" value="323">Indian Super League</option>
            </Select>
            </Box>

            {/* {exhausted &&
            <>
            <Text mt="40%" textAlign="center" fontSize="3xl" color="#ffffff">
                OOP's
            </Text>
            <Text textAlign="center" fontSize="sm" color="#ffffff">
                No more API calls left,
            </Text>
            <Text textAlign="center" fontSize="sm" color="#ffffff">
                Please comeback tomorrow
            </Text>
            </>} */}

            {loading ?
            <Center>
            <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.600'
            size='xl'
            mt={["50%","10%"]}
            />
            </Center>
            :
            <>
            {playerData &&
            <>
            {playerData.data.response &&
            <>
            {playerData.data.response.map((data: any) => (
            <Box mt="5" key={data.player.id}>
                <Box bg="#212121" borderRadius="5px" py="4" boxShadow="lg">
                    <Box display="flex" color="#ffffff" mx="1">
                        <Box>
                        <Image
                        ml="3"
                        borderRadius='full'
                        boxSize='90px'
                        src={data.player.photo}
                        alt='Dan Abramov'
                        />
                        </Box>
                        <Box ml="5">
                            {
                               data.statistics[0].games.position==="Attacker" ?
                               <Text fontSize="md" color="red">{data.statistics[0].games.position}</Text>
                               :
                               (data.statistics[0].games.position==="Midfielder" ?
                               <Text fontSize="md" color="green">{data.statistics[0].games.position}</Text>
                               :
                               <Text fontSize="md" color="blue">{data.statistics[0].games.position}</Text>
                               )
                            }
                            <Text mt="1" fontSize="lg" fontWeight="700">{data.player.name}</Text>
                            <Text fontSize="md">{data.statistics[0].team.name}</Text>
                        </Box>
                    </Box>
                    <Box mt="4" display="flex" justifyContent="space-evenly" 
                    color="#ffffff" textAlign="center" fontWeight="700">
                        <Box bg="#171717" px="5" py="4" borderRadius="5px" boxShadow="md">
                            <Text>Games</Text>
                            <Text>{data.statistics[0].games.appearences}</Text>
                        </Box>
                        <Box bg="#171717" px="5" py="4" borderRadius="5px">
                            <Text>Assists</Text>
                            <Text>{data.statistics[0].goals.assists}</Text>
                        </Box>
                        <Box bg="#171717" px="6" py="4" borderRadius="5px">
                            <Text>Goals</Text>
                            <Text>{data.statistics[0].goals.total}</Text>
                        </Box>
                    </Box>
                </Box>
            </Box>))}
            </>}
            </>}
            </>}

        </Container>
    );
}

export default Players;